import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  Modal, 
  TextField, 
  Typography
} from '@mui/material';

import LoadingButton from '../../../../../components/buttons/Button';

import { 
  CreateTenantBIZcore, 
  GetTenantsBIZcore, 
  UpdateTenantBIZcore 
} from '../../../../../redux/actions/business/core/tenantsActions';

import global from "../../../../../global.scss";

const Data = {
  Id: "",
  Name: ""
};

const TenantsModal = ({
  open, 
  setOpen, 
  title,
  update,
  page, 
  rowsPerPage
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(1);

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(1);
  }

  useEffect(() => {
    try {
      if(open){
        if(update.defaultMode === 1){
          // mode = 1 - create tenant
          setMode(1);
        }else if(update.defaultMode === 2){
          // mode = 2 - edit tenant
          setMode(2);
          setFormData({
            ...formData,
            Id: update.tenant_id || "",
            Name: update.tenant_name || ""
          })
        }else{
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // --------------- handle change ----------------
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if(mode === 1){
      // create tenant
      let obj = {
        tenant_id: formData.Id || "",
        tenant_name: formData.Name || "",
      };
      dispatch(CreateTenantBIZcore(obj, setLoading)).then(() => {
        dispatch(GetTenantsBIZcore(page+1, rowsPerPage, "", setLoading)).then(() => {
          handleClose();
        })
      });
    }else if(mode === 2){
      // update tenant
      let obj = {
        tenant_id: formData.Id || "",
        tenant_name: formData.Name || "",
      };
      dispatch(UpdateTenantBIZcore(update.tenant_id, obj, setLoading)).then(() => {
        dispatch(GetTenantsBIZcore(page+1, rowsPerPage, "", setLoading)).then(() => {
          handleClose();
        })
      });
    }else{
      toast.error("Invalid modal");
      handleClose();
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow"
        width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"}
            sx={{ padding: "15px"}}>
            <Typography variant='h6' sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>
            {
              mode === 1
              &&
              <Box 
                className="flexCenterSBRow"
                gap={"15px"}
                mb={"15px"}>
                <TextField 
                  label="Id"
                  fullWidth
                  name="Id"
                  value={formData.Id}
                  onChange={handleChange}
                  inputProps={{ maxLength: 40 }}
                  />
              </Box>
            }
            <Box 
              className="flexCenterSBRow"
              gap={"15px"}
              mb={"15px"}>
              <TextField 
                label="Name"
                fullWidth
                name="Name"
                value={formData.Name}
                onChange={handleChange}
                inputProps={{ maxLength: 100 }}
                />
            </Box>
          </Box>
          <Divider
           sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }}/>
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px"}}>
            <Button variant='text'
              onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton 
              variant='contained'
              loading={loading}
              disabled={!(formData.Name !== "" && formData.Id !== "")}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default TenantsModal;